import { render, staticRenderFns } from "./WritingHeader.vue?vue&type=template&id=47dcf4b2&"
import script from "./WritingHeader.vue?vue&type=script&lang=js&"
export * from "./WritingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports